import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { CompanyService } from '../companies/company.service';

@Component({
  selector   : 'wor-vehicle-actions',
  template: require('./vehicle.actions.component.html')
})
export class VehicleActionsComponent {
  @Input() record: any;

  @Output() onBookingClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditClick   : EventEmitter<any> = new EventEmitter();
  @Output() onInvoiceClick: EventEmitter<any> = new EventEmitter();

  constructor (
    private companyService: CompanyService
  ) {}

  isDealer () : boolean {
    return this.companyService.isDealer();
  }
}
